import { oc } from '@orpc/contract';
import { idParamSchema } from '../../common/schemas/id.schemas.js';
import { vehicleSchema } from '../schemas/vehicles.schemas.js';
export const archiveVehicleContract = oc
    .route({
    method: 'POST',
    path: '/vehicles/{id}/archive',
    tags: ['Vehicles'],
    summary: 'Archive a vehicle',
    description: 'MANAGER only. Vehicles are never deleted, so historical runs keep resolving.',
})
    .input(idParamSchema)
    .output(vehicleSchema);
//# sourceMappingURL=archive-vehicle.contract.js.map